import React from 'react'

const CANV2021 = () => {
  return (
    <div>
        CA-NV2021 - COMING SOON
    </div>
  )
}

export default CANV2021